export default __webpack_public_path__ + "static/media/view_headline.d3f78f87.svg";